<template>

    <b-form @submit.prevent="submitForm">
        <div class="withdraw-balance-card mb-4">
            <div v-if='selectedMt5Account' class="text-12 text-uppercase font-weight-600 mb-1"
                style="color:#64748b;letter-spacing:.04em;">
                {{ $t('mt5_balance') }}
            </div>
            <div class="text-32 font-weight-800" style="color:#0f172a;">
                <template v-if="selectedMt5Account">
                    USD {{ parseFloat(selectedMt5Account.balance).toFixed(2) }}
                </template>
                <template v-else>
                    {{ $t('no_mt5_account') }}
                </template>
            </div>
        </div>
        <div v-for="value, name in form" :key="name" class="position-relative">

            <FormInput v-if="name !== 'mt5_id'" :name="name" :value="value" @updateInput="(n) => form[name] = n"
                :readonly="name == 'transfer_to'">
            </FormInput>
            <div v-else class="form-group">
                <label class="label-text">{{ $t('mt5_id') }}</label>
                <b-form-select v-model="form[name]" :options="mt5Options" value-field="value" text-field="name"
                    class="form-control custom-select mb-3" />
            </div>
        </div>
        <div class="flex-grow-1"></div>
        <b-button variant="primary" class="mt-2" type="submit">
            {{ $t('confirm') }}
        </b-button>

    </b-form>




</template>

<script>
import FormInput from '../../components/formInput.vue'
import { withdrawFromMt5 } from '@/system/request/api/api';
import { handleError } from '../../system/request/handleRes';
export default {
    components: { FormInput },

    data() {
        return {
            form: {
                mt5_id: '',
                transfer_to: this.$t('point1'),
                amount: '',
                sec_password: '',

            },
            mt5List: [],
        }
    },
    watch: {


    },
    computed: {
        mt5Options() {
            if (!this.mt5List || this.mt5List.length === 0) {
                return [
                    { name: this.$t('no_mt5_account'), value: '', disabled: true }
                ];
            }

            return this.mt5List.map(acc => ({
                name: `MT5 ${acc.mt5} (${acc.mt5_group})`,
                value: acc.id
            }));
        },
        selectedMt5Account() {
            return this.mt5List.find(acc => acc.id === this.form.mt5_id) || null;
        }
    },
    methods: {
        // getMt5Account() {
        //     this.$root.isLoading = true;
        //     getMt5Account()
        //         .then(value => {
        //             if (value.data.error_code === "0") {
        //                 this.mt5List = value.data.data.mt5;
        //                 if (this.mt5List.length > 0) {
        //                     this.form.mt5_id = this.mt5List[0].id;
        //                 } else {
        //                     this.form.mt5_id = ''; 
        //                 } 
        //             } else {
        //                 this.$root.makeToast("danger", this.$t(value.data.message));
        //             }
        //         })
        //         .catch(error => {
        //             this.$root.makeToast("warning", this.$t(handleError(error)));
        //         })
        //         .finally(() => {
        //             this.$root.isLoading = false;
        //         });
        // },
        submitForm() {
            for (const key in this.form) {
                if (!this.form[key]) {
                    this.$root.makeToast("warning", this.$t('please_fill_all_fields'), '');
                    return;
                }
            }
            let formData = new FormData();

            for (const key in this.form) {
                const element = this.form[key];
                formData.append(key, element);
            }

            var self = this;
            self.$root.isLoading = true;
            var result = withdrawFromMt5(formData);

            result
                .then(function (value) {
                    if (value.data.error_code == 0) {
                        self.$root.makeToast("success", self.$t('success_withdraw'), '');
                        self.$root.getInfo();
                        self.sec_pwd = "";
                        self.$router.push('/web/accounts/trading_accounts');
                    } else {
                        self.$root.makeToast("danger", self.$t(value.data.message), '');
                    }
                    self.$root.isLoading = false;
                    self.sec_pwd = "";
                })
                .catch(function (error) {
                    self.$root.makeToast("warning", self.$t(handleError(error)), '');
                    self.$root.isLoading = false;
                    self.sec_pwd = "";
                });
        },
    },
    // mounted() {
    //     this.getMt5Account();
    // }


}
</script>